import React from 'react'

import GroupChatAvatarBookmarkedIndicator from './group_chat_avatar_bookmarked_indicator'

const GroupChatAvatar = (props) => {
  const size = props.size || 36
  const initials = props.initials.substring(0, 3)
  const letterClass = initials.length < 3 ? 'two-letters' : 'three-letters'
  const fontSize = initials.length < 3 ? size * 0.36 : size * 0.30

  return (
    <div className={'group-chat-avatar ' + letterClass} style={{width: size, height: size, lineHeight: `${size}px`, fontSize}}>
      {initials}
      <GroupChatAvatarBookmarkedIndicator groupId={props.groupId}/>
    </div>
  )
}

export default GroupChatAvatar



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chat_avatar.js
 **/